/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.DecimalRange = (function () {

    function DecimalRange () {

        Monet.UI.Fields.Decimal.apply (this, arguments);

        this.value = {
            ini: '',
            fin: ''
        };

        var baseElement = null;

        this.getValue = function () {

            if(this.inputIni && this.inputFin){
                this.value.ini = this.inputIni.value;
                this.value.fin = this.inputFin.value;
            }
            var formattedIniValue = '';
            if(this.value.ini){
                formattedIniValue = new Monet.Format.DECIMAL(this.value.ini).parseFloat().getValue();
            }

            var formattedFinValue = '';
            if(this.value.fin){
                formattedFinValue = new Monet.Format.DECIMAL(this.value.fin).parseFloat().getValue();
            }

            return {
                ini: formattedIniValue,
                fin: formattedFinValue
            };

        };

        this.isEmpty = function () {
            return !(this.getValue() && this.getValue().ini && this.getValue().fin);
        };

        this.setValue = function (values) {
            this.value.ini = values.ini || "";
            this.value.fin = values.fin || "";

            if(this.inputIni && this.inputFin){
                this.inputIni.value = new Monet.Format.DECIMAL(this.value.ini).format().getValue();
                this.inputFin.value = new Monet.Format.DECIMAL(this.value.fin).format().getValue();
            }
        };

        this.createElement = function () {

            if(!baseElement){

                this.inputIni = document.createElement('input');
                this.inputFin = document.createElement('input');

                this.inputIni.type = 'text';
                this.inputIni.className = 'decimalFieldOld';

                this.inputFin.type = 'text';
                this.inputFin.className = 'decimalFieldOld';

                //"Integers are considered reliable (numbers without a period or exponent notation) to 15 digits (9e15)"
                //I think that is sufficient to Decimal also.
                this.inputIni.maxLength = 20;
                this.inputFin.maxLength = 20;

                baseElement = this.inputIni;

                this.rootEl.appendChild (this.inputIni);
                this.rootEl.appendChild (this.inputFin);
            }

        };

        this.addEventListeners = function () {

            $(this.inputIni).on("keyup blur focus",function (e) {

                e.preventDefault();

                var expre = /[^0-9,.]/g;

                if ($(this).val().match(expre)) {
                    $(this).val($(this).val().replace(expre, ''));
                }


            }).maskMoney({
                prefix: '',
                decimal: Monet.I18n.locale.decimalSymbol,
                thousands: Monet.I18n.locale.digitalGrouping,
                allowNegative: true,
                allowZero: true
            });


            $(this.inputFin).on("keyup blur focus",function (e) {

                e.preventDefault();

                var expre = /[^0-9,.-]/g;

                if ($(this).val().match(expre)) {
                    $(this).val($(this).val().replace(expre, ''));
                }


            }).maskMoney({
                prefix: '',
                decimal: Monet.I18n.locale.decimalSymbol,
                thousands: Monet.I18n.locale.digitalGrouping,
                allowNegative: true,
                allowZero: true
            });

        };

        this.clear = function () {
            this.setValue({
                ini: '',
                fin: ''
            });
        };

        this.render = function () {

            this.createElement();
            this.setValue(this.value);
            this.addEventListeners();
            return this.rootEl;

        };

    }

    return DecimalRange;

}());